import React from 'react';
import { useState, useEffect } from 'react';
const ItemSections = () => {

    const services = [
        {
            id: 1,
            title: "Drayage",
            description: "We pride ourselves in reducing waste and down-time as much as possible and can change a driver’s course on a dime.",
            img: "https://onpoint-alpha.vercel.app/assets/images/project/project-2-1.jpg",
            buttonText: "Get Quote",
            points: [
                {
                    text: "Dedicated Fleet Programs"
                },
                {
                    text: "Dedicated Dispatch Program"
                },
                {
                    text: "Dedicated Analyst Program"
                },
                {
                    text: "Ocean Container Availability Tracking"
                },
                {
                    text: "Custom Chassis Programs"
                },
                {
                    text: "Ocean/Rail Land Bridge Programs"
                },
                {
                    text: "Refrigerated Container Service"
                },
                {
                    text: "California Air Resources Bond (CARB) Compliant Truck Fleet"
                },

            ]
        },
        {
            id: 1,
            title: "Transload",
            description: " ",
            img: "https://onpoint-alpha.vercel.app/assets/images/project/project-2-2.jpg",
            buttonText: "Get Quote",
            points: [
                {
                    text: "C-TPAT Compliant/Certified"
                },
                {
                    text: "Location, Location, Location…Yard and Transload Space On and Near all Port Property in Oakland and the Pacific Northwest"
                },
                {
                    text: "Container Storage with Top Pick Capabilities"
                },
                {
                    text: "EDI Connectivity for Live Updated Information"
                },
                {
                    text: "Container Status Visibility (Yard Management System)"
                }
            ]
        },


    ]

    return (
        <>
        {services.map((service) => (
            <div className='service-item-section' key={service.id}>
                <div className='row'>
                    <div className='col-lg-12 d-flex justify-content-between mb-5'>
                        <h1 className='service-item-title'>{service.title}</h1>
                        <button className='renoxweb-blue-btn' onClick={service.onClick}>{service.buttonText}</button>
                    </div>
                    <div className='col-lg-4 '>                      
                        <p className='service-item-description'>{service.description}</p>
                        <img className='service-item-img' src={service.img} alt={service.title} />
                    </div>
                    <div className='col-lg-8'>
                        <ul className='service-item-points'>
                            {service.points.map((point) => (
                                <li className='service-item-point' key={point.id}>{point.text}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        ))}
        </>
    );
};

export default ItemSections;